import React, { useMemo } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, EntryPointParams } from './entrypoint';

export const PremiumPopup = () => {
	const entryPointParams: EntryPointParams = useMemo(() => ({}), []);

	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<PopupEntryPoint
				entryPoint={entryPoint}
				entryPointParams={entryPointParams}
				placement={'bottom-start'}
				onClose={onClose}
			/>
		</AnalyticsContext>
	);
};
